const getQuantitiveStatus = (value, type) => {
  if (!type || !type.length || Number(value) !== value) {
    return 'undefined';
  }

  const checkValueInRange = (min, max) => {
    if (
      (min && max && value <= min && value >= max) ||
      (min && !max && value <= min) ||
      (!min && max && value >= max)
    ) {
      return true;
    }

    return false;
  };

  const goodStatus = 'normal';
  const undefinedStatus = 'undefined';
  let badStatus = undefinedStatus;
  let midStatus = undefinedStatus;
  let bad = [];
  let mid = [];
  let good = [];

  if (type === 'weight') {
    badStatus = 'severe';
    midStatus = 'mild';
    bad = [0.5, null];
    mid = [0.5, 0.6];
    good = [null, 0.6];
  } else if (type === 'volume') {
    badStatus = 'diffuse';
    midStatus = 'moderate';
    bad = [0.2, null];
    mid = [0.2, 0.35];
    good = [null, 0.35];
  }

  if (bad && bad.length && checkValueInRange(bad[0], bad[1])) {
    return badStatus;
  }

  if (mid && mid.length && checkValueInRange(mid[0], mid[1])) {
    return midStatus;
  }

  if (good && good.length && checkValueInRange(good[0], good[1])) {
    return goodStatus;
  }

  return undefinedStatus;
};

export default getQuantitiveStatus;
